// extracted by mini-css-extract-plugin
module.exports = {"price":"TotalPrice_price__3PhcJ"};